import { render, staticRenderFns } from "./AscPlotOverlaysTabWrapper.vue?vue&type=template&id=6ea74e06&"
import script from "./AscPlotOverlaysTabWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPlotOverlaysTabWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPlotOverlaysTabWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
